import { render, staticRenderFns } from "./team2.vue?vue&type=template&id=3041a405&scoped=true&"
import script from "./team2.vue?vue&type=script&lang=js&"
export * from "./team2.vue?vue&type=script&lang=js&"
import style0 from "./team2.vue?vue&type=style&index=0&id=3041a405&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041a405",
  null
  
)

export default component.exports